import Input from "../../components/Input/Input";

const ClientForm = ({formik}) => {
    return (
        <form id="client-form" onSubmit={formik.handleSubmit}>
            <Input
                name="name"
                label="Company Name"
                formik={formik}
            />
            <Input
                name="email"
                label="Email"
                formik={formik}
            />
            <Input
                name="color"
                label="Color"
                type="color"
                required={false}
                formik={formik}
            />
            <Input
                name="logo"
                label="Profile Picture"
                type="picture"
                required={false}
                formik={formik}
            />

        </form>
    );
};

export default ClientForm;